import { Flex } from 'components/Box';
import Marquee from 'react-double-marquee';
import styled from 'styled-components';

const marqueeProps = {
    direction: "left",
    children: "We are dispatching payment daily at 3:00 UTC",
    speed: 0.09,
    delay: 500,
    childMargin: 700,
    scrollWhen: "always",
}

const MarqueeBackground = styled(Flex)`
    height: 50px;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.colors.primary};
    white-space: nowrap;
`

const FooComponent: React.FC = () => {
    return (
        <MarqueeBackground>

            <Marquee {...marqueeProps}></Marquee>

        </MarqueeBackground>
    );
}
export default FooComponent;